import type { ScoreReader } from '@upright/common/model/output/scores/score-reader';
import { max } from 'lodash';
import { getDimensionTotal } from '../../../../../../../common/model/output/scores';
import { ImpactScoresByIVV } from '../../../../../../../common/model/output/scores/types';
import { orderedDimensions, Valence } from '../../../../../../../common/model/types';

/**
 * Get the maximum x value for the chart, reads full score object
 */
export function getMaxX(data: ImpactScoresByIVV) {
  const maxDimensionValue = getMaxDimensionValue(data);
  // TODO JO: temporarily disabled lower bound
  // if (maxDimensionValue < 3) {
  //   return 3;
  // }
  return maxDimensionValue;
}

function getMaxDimensionValue(data: ImpactScoresByIVV) {
  return orderedDimensions.reduce<number>((current, dimension) => {
    return Math.max(
      current,
      getDimensionTotal(data, dimension, undefined, Valence.POSITIVE),
      getDimensionTotal(data, dimension, undefined, Valence.NEGATIVE),
    );
  }, 0);
}

/**
 * Get the maximum x value for the multiple entity chart, reads score via a provided function
 */
export function getMultiseriesMaxXFromScoreReaderFunctions(
  scoreReaderFunctions: ScoreReaderFunction[] | undefined,
): number {
  return (
    max(
      scoreReaderFunctions?.map(scoreReaderFunction =>
        getMaxDimensionValueFromScoreReaderFunction(scoreReaderFunction),
      ),
    ) || 1
  );
}

type ScoreReaderFunction = ScoreReader['readScore'];

function getMaxDimensionValueFromScoreReaderFunction(scoreReaderFunction: ScoreReaderFunction) {
  return orderedDimensions.reduce<number>((current, dimension) => {
    return Math.max(
      current,
      scoreReaderFunction(undefined, dimension, undefined, Valence.POSITIVE) ?? 0,
      scoreReaderFunction(undefined, dimension, undefined, Valence.NEGATIVE) ?? 0,
    );
  }, 0);
}
